import { Injectable } from '@angular/core';
import { DeficiencyTicketsDaoService } from '../deficiency-tickets-dao.service';
import {
  DbPersistenceService,
  Query,
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { LocalDeficiencyTicketDbTableDefinition } from './local-deficiency-tickets-db-table-definition';
import { DeficiencyTicketDbTableDefinition } from './deficiency-tickets-db-table-definition';
import { DeficiencyTicket } from 'src/app/_model/deficiency-ticket';
import { LocalStatusService } from 'src/app/_services/local-status/local-status.service';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { IMSId } from 'src/app/_model/ims-object';

@Injectable()
export class DeficiencyTicketsDbDaoService
  implements DeficiencyTicketsDaoService
{
  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private deficiencyTicketTableDefinition: DeficiencyTicketDbTableDefinition,
    private localDeficiencyTicketTableDefinition: LocalDeficiencyTicketDbTableDefinition,
    private localStatusService: LocalStatusService,
    private appParameter: AppParameterService,
  ) {}

  public async saveDeficiencyTickets(
    deficiencyTickets: DeficiencyTicket[],
  ): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();

      var deficiencyTicketQueries: Query[] = [];
      for (const deficiencyTicket of deficiencyTickets) {
        let parameters;
        let values;
        let fields;
        let table;
        console.log(
          this.constructor.name,
          'is tt local?',
          deficiencyTicket.isLocal(),
          deficiencyTicket,
        );
        if (deficiencyTicket.isLocal()) {
          parameters = [
            deficiencyTicket.id.secondaryId,
            deficiencyTicket.databag
              ? JSON.stringify(deficiencyTicket.databag)
              : undefined,
            deficiencyTicket.extCode,
            deficiencyTicket.caseNumber,
            deficiencyTicket.caseNumberWithPrefix,
            deficiencyTicket.alertCount,
            deficiencyTicket.extType,
            deficiencyTicket.info,
            deficiencyTicket.reason
              ? Number(deficiencyTicket.reason.getImsId())
              : undefined,
            deficiencyTicket.reason ? deficiencyTicket.reason.label : undefined,
            deficiencyTicket.owner
              ? Number(deficiencyTicket.owner.getImsId())
              : undefined,
            deficiencyTicket.owner ? deficiencyTicket.owner.label : undefined,
            deficiencyTicket.ownerObjRef,
            deficiencyTicket.entityCreatedTstamp,
            deficiencyTicket.entityCreatedUser,
            deficiencyTicket.entityCreatedDeviceToken,
            deficiencyTicket.entityCreatedLocalDeviceId,
            deficiencyTicket.title,
            deficiencyTicket.description,
            deficiencyTicket.creator
              ? Number(deficiencyTicket.creator.getImsId())
              : undefined,
            deficiencyTicket.creator
              ? deficiencyTicket.creator.label
              : undefined,
            deficiencyTicket.assignee
              ? Number(deficiencyTicket.assignee.getImsId())
              : undefined,
            deficiencyTicket.assignee
              ? deficiencyTicket.assignee.label
              : undefined,
            deficiencyTicket.assigneeObjRef,
            deficiencyTicket.pin
              ? Number(deficiencyTicket.pin.getImsId())
              : undefined,
            deficiencyTicket.pin ? deficiencyTicket.pin.label : undefined,
            deficiencyTicket.completionDate,
            deficiencyTicket.latestCompletionDate,
            deficiencyTicket.status,
            deficiencyTicket.external ? deficiencyTicket.external : false,
            deficiencyTicket.priority,
            deficiencyTicket.receiptTstamp,
            deficiencyTicket.predecessor?.id?.imsId,
            deficiencyTicket.predecessor?.id?.secondaryId,
            deficiencyTicket.predecessor?.label,
          ];
          values =
            '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)';
          fields =
            '(id, databag, extcode, casenumber, casenumberwithprefix, alertcount, exttype, info, ' +
            'reasonid, reasonlabel, ownerid, ownerlabel, ownerobjref, entitycreatedtstamp, entitycreateduser, ' +
            'entitycreateddevicetoken, entitycreatedlocaldeviceid, title, description, creatorid, creatorlabel, ' +
            'assigneeid, assigneelabel, assigneeobjref, pinid, pinlabel, completiondate, latestcompletiondate, ' +
            'status, external, priority, receipttstamp, predecessorid, predecessorsecondaryid, predecessorlabel)';
          table = this.localDeficiencyTicketTableDefinition.tableName;
        } else {
          parameters = [
            deficiencyTicket.id.imsId,
            deficiencyTicket.databag
              ? JSON.stringify(deficiencyTicket.databag)
              : undefined,
            deficiencyTicket.extCode,
            deficiencyTicket.caseNumber,
            deficiencyTicket.caseNumberWithPrefix,
            deficiencyTicket.alertCount,
            deficiencyTicket.extType,
            deficiencyTicket.info,
            deficiencyTicket.reason
              ? Number(deficiencyTicket.reason.getImsId())
              : undefined,
            deficiencyTicket.reason ? deficiencyTicket.reason.label : undefined,
            deficiencyTicket.owner
              ? Number(deficiencyTicket.owner.getImsId())
              : undefined,
            deficiencyTicket.owner ? deficiencyTicket.owner.label : undefined,
            deficiencyTicket.ownerObjRef,
            deficiencyTicket.entityCreatedTstamp,
            deficiencyTicket.entityCreatedUser,
            deficiencyTicket.entityCreatedDeviceToken,
            deficiencyTicket.entityCreatedLocalDeviceId,
            deficiencyTicket.title,
            deficiencyTicket.description,
            deficiencyTicket.creator
              ? Number(deficiencyTicket.creator.getImsId())
              : undefined,
            deficiencyTicket.creator
              ? deficiencyTicket.creator.label
              : undefined,
            deficiencyTicket.assignee
              ? Number(deficiencyTicket.assignee.getImsId())
              : undefined,
            deficiencyTicket.assignee
              ? deficiencyTicket.assignee.label
              : undefined,
            deficiencyTicket.assigneeObjRef,
            deficiencyTicket.pin
              ? Number(deficiencyTicket.pin.getImsId())
              : undefined,
            deficiencyTicket.pin ? deficiencyTicket.pin.label : undefined,
            deficiencyTicket.completionDate,
            deficiencyTicket.latestCompletionDate,
            deficiencyTicket.status,
            deficiencyTicket.external ? deficiencyTicket.external : false,
            deficiencyTicket.priority,
            deficiencyTicket.receiptTstamp,
            deficiencyTicket.predecessor?.id?.imsId,
            deficiencyTicket.predecessor?.id?.secondaryId,
            deficiencyTicket.predecessor?.label,
          ];
          values =
            '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)';
          fields =
            '(id, databag, extcode, casenumber, casenumberwithprefix, alertcount, exttype, info, ' +
            'reasonid, reasonlabel, ownerid, ownerlabel, ownerobjref, entitycreatedtstamp, entitycreateduser, ' +
            'entitycreateddevicetoken, entitycreatedlocaldeviceid, title, description, creatorid, creatorlabel, ' +
            'assigneeid, assigneelabel, assigneeobjref, pinid, pinlabel, completiondate, latestcompletiondate, ' +
            'status, external, priority, receipttstamp, predecessorid, predecessorsecondaryid, predecessorlabel)';
          table = this.deficiencyTicketTableDefinition.tableName;
        }
        let deficiencyTicketQuery: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
            table +
            ' ' +
            fields +
            ' VALUES ' +
            values,
          parameters: parameters,
        };
        await this.localStatusService.storeLocalDeficiencyTicketStatus(
          deficiencyTicket,
        );
        deficiencyTicketQueries.push(deficiencyTicketQuery);
      }

      const result = await this.dbPersistenceService.executeBatch(
        db,
        deficiencyTicketQueries,
      );
    } catch (error) {
      this.logger.log(
        'Error saving deficiencyTickets to db',
        error,
        '-',
        error?.message,
      );
    }
  }

  public async createDeficiencyTicket(
    deficiencyTicket: DeficiencyTicket,
  ): Promise<DeficiencyTicket> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let parameters = [
        deficiencyTicket.databag
          ? JSON.stringify(deficiencyTicket.databag)
          : undefined,
        deficiencyTicket.extCode,
        deficiencyTicket.caseNumber,
        deficiencyTicket.caseNumberWithPrefix,
        deficiencyTicket.alertCount,
        deficiencyTicket.extType,
        deficiencyTicket.info,
        deficiencyTicket.reason
          ? Number(deficiencyTicket.reason.getImsId())
          : undefined,
        deficiencyTicket.reason ? deficiencyTicket.reason.label : undefined,
        deficiencyTicket.owner
          ? Number(deficiencyTicket.owner.getImsId())
          : undefined,
        deficiencyTicket.owner ? deficiencyTicket.owner.label : undefined,
        deficiencyTicket.ownerObjRef,
        deficiencyTicket.entityCreatedTstamp,
        deficiencyTicket.entityCreatedUser,
        deficiencyTicket.entityCreatedDeviceToken,
        deficiencyTicket.entityCreatedLocalDeviceId,
        deficiencyTicket.title,
        deficiencyTicket.description,
        deficiencyTicket.creator
          ? Number(deficiencyTicket.creator.getImsId())
          : undefined,
        deficiencyTicket.creator ? deficiencyTicket.creator.label : undefined,
        deficiencyTicket.assignee
          ? Number(deficiencyTicket.assignee.getImsId())
          : undefined,
        deficiencyTicket.assignee ? deficiencyTicket.assignee.label : undefined,
        deficiencyTicket.assigneeObjRef,
        deficiencyTicket.pin
          ? Number(deficiencyTicket.pin.getImsId())
          : undefined,
        deficiencyTicket.pin ? deficiencyTicket.pin.label : undefined,
        deficiencyTicket.completionDate,
        deficiencyTicket.latestCompletionDate,
        deficiencyTicket.status,
        deficiencyTicket.external ? deficiencyTicket.external : false,
        deficiencyTicket.priority,
        deficiencyTicket.receiptTstamp,
        deficiencyTicket.predecessor?.id?.imsId,
        deficiencyTicket.predecessor?.id?.secondaryId,
        deficiencyTicket.predecessor?.label,
      ];
      let values =
        '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)';
      let fields =
        '(databag, extcode, casenumber, casenumberwithprefix, alertcount, exttype, info, ' +
        'reasonid, reasonlabel, ownerid, ownerlabel, ownerobjref, entitycreatedtstamp, entitycreateduser, ' +
        'entitycreateddevicetoken, entitycreatedlocaldeviceid, title, description, creatorid, creatorlabel, ' +
        'assigneeid, assigneelabel, assigneeobjref, pinid, pinlabel, completiondate, latestcompletiondate, ' +
        'status, external, priority, receipttstamp, predecessorid, predecessorsecondaryid, predecessorlabel)';
      let table = this.localDeficiencyTicketTableDefinition.tableName;

      let deficiencyTicketQuery: Query = {
        statement:
          'INSERT OR REPLACE INTO ' +
          table +
          ' ' +
          fields +
          ' VALUES ' +
          values,
        parameters: parameters,
      };

      this.logger.log(
        this.constructor.name,
        'store local deficiencyticket with query',
        deficiencyTicketQuery,
      );

      await this.dbPersistenceService.executeStatement(db, deficiencyTicketQuery);
      let res = await this.dbPersistenceService.executeQuery(db, {
        statement: 'select last_insert_rowid() as id',
        parameters: [],
      });
      if (res && res.values) {
        deficiencyTicket.id.secondaryId = res.values.shift()?.id;
        deficiencyTicket.entityCreatedLocalDeviceId =
          deficiencyTicket.id.secondaryId;
        this.logger.log(
          this.constructor.name,
          'Updated deficiencyTicket secondary id',
          deficiencyTicket.id.secondaryId,
        );
      }
      return deficiencyTicket;
    } catch (error) {
      this.logger.log(
        'Error saving DeficiencyTicket to db',
        error,
        '-',
        error?.message,
      );
      return undefined;
    }
  }

  public async getDeficiencyTickets(): Promise<DeficiencyTicket[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let deficiencyTickets: DeficiencyTicket[] = [];

      // Get Synced DeficiencyTickets
      let data = await this.dbPersistenceService.executeQuery(db, {
        statement:
          'SELECT * FROM ' +
          this.deficiencyTicketTableDefinition.tableName +
          ';',
        parameters: null,
      });
      this.logger.log(
        this.constructor.name,
        data.values?.length,
        'deficiencytickets in remote db',
      );
      for (let i = 0; i < (data.values?.length ?? 0); i++) {
        let row = data.values[i];

        let localStatus =
          await this.localStatusService.loadLocalDeficiencyTicketStatus({
            imsId: row['id'],
            secondaryId: undefined,
            objRef: 'ims/DeficiencyTicket',
          });
        deficiencyTickets.push(
          DeficiencyTicket.fromDto(
            {
              id: row['id'],
              secondaryid: undefined,
              extcode: row['extcode'],
              casenumber: +row['casenumber'],
              casenumberwithprefix: row['casenumberwithprefix'],
              alertcount: +row['alertcount'],
              exttype: row['exttype'],
              info: row['info'],
              reason: {
                id: row['reasonid'],
                label: row['reasonlabel'],
              },
              owner: {
                id: row['ownerid'],
                label: row['ownerlabel'],
              },
              ownerobjref: row['ownerobjref'],
              entitycreatedtstamp: row['entitycreatedtstamp'],
              entitycreateduser: row['entitycreateduser'],
              entitycreateddevicetoken: row['entitycreateddevicetoken'],
              entitycreatedlocaldeviceid: row['entitycreatedlocaldeviceid'],
              title: row['title'],
              description: row['description'],
              completiondate: row['completiondate'],
              latestcompletiondate: row['latestcompletiondate'],
              status: row['status'],
              external: row['external'] === 1,
              creator: {
                id: row['creatorid'],
                label: row['creatorlabel'],
              },
              assigneeobjref: row['assigneeobjref'],
              assignee: {
                id: row['assigneeid'],
                label: row['assigneelabel'],
              },
              pin: {
                id: row['pinid'],
                label: row['pinlabel'],
              },
              priority: row['priority'],
              receipttstamp: row['receipttstamp'],
              predecessor:
                row['predecessorid'] != undefined || row['predecessorlabel'] != undefined
                  ? { id: row['predecessorid'], label: row['predecessorlabel'] }
                  : undefined,
              predecessorsecondaryid: row['predecessorsecondaryid'],
            },
            localStatus,
            row['databag'] ? JSON.parse(row['databag']) : undefined,
            this.appParameter.getFormatLabelForObject('ims/DeficiencyTicket'),
          ),
        );
      }

      // Get local generated DeficiencyTickets
      let localData = await this.dbPersistenceService.executeQuery(db, {
        statement:
          'SELECT * FROM ' +
          this.localDeficiencyTicketTableDefinition.tableName +
          ';',
        parameters: null,
      });
      this.logger.log(
        this.constructor.name,
        localData.values?.length,
        'deficiencytickets in local db',
      );
      for (let i = 0; i < (localData.values?.length ?? 0); i++) {
        let row = localData.values[i];
        let localStatus =
          await this.localStatusService.loadLocalDeficiencyTicketStatus({
            imsId: undefined,
            secondaryId: row['id'],
            objRef: 'ims/DeficiencyTicket',
          });
        deficiencyTickets.push(
          DeficiencyTicket.fromDto(
            {
              id: undefined,
              secondaryid: row['id'],
              extcode: row['extcode'],
              casenumber: +row['casenumber'],
              casenumberwithprefix: row['casenumberwithprefix'],
              alertcount: +row['alertcount'],
              exttype: row['exttype'],
              info: row['info'],
              reason: {
                id: row['reasonid'],
                label: row['reasonlabel'],
              },
              owner: {
                id: row['ownerid'],
                label: row['ownerlabel'],
              },
              ownerobjref: row['ownerobjref'],
              entitycreatedtstamp: row['entitycreatedtstamp'],
              entitycreateduser: row['entitycreateduser'],
              entitycreateddevicetoken: row['entitycreateddevicetoken'],
              entitycreatedlocaldeviceid:
                row['entitycreatedlocaldeviceid'] ?? row['id'],
              title: row['title'],
              description: row['description'],
              completiondate: row['completiondate'],
              latestcompletiondate: row['latestcompletiondate'],
              status: row['status'],
              external: row['external'] === 1,
              creator: {
                id: row['creatorid'],
                label: row['creatorlabel'],
              },
              assigneeobjref: row['assigneeobjref'],
              assignee: {
                id: row['assigneeid'],
                label: row['assigneelabel'],
              },
              pin: {
                id: row['pinid'],
                label: row['pinlabel'],
              },
              priority: row['priority'],
              receipttstamp: row['receipttstamp'],
              predecessor:
                row['predecessorid'] != undefined || row['predecessorlabel'] != undefined
                  ? { id: row['predecessorid'], label: row['predecessorlabel'] }
                  : undefined,
              predecessorsecondaryid: row['predecessorsecondaryid'],
            },
            localStatus,
            row['databag'] ? JSON.parse(row['databag']) : undefined,
            this.appParameter.getFormatLabelForObject('ims/DeficiencyTicket'),
          ),
        );
      }

      return deficiencyTickets;
    } catch (error) {
      this.logger.log('Error reading DeficiencyTickets from db', error);
      return undefined;
    }
  }

  public async deleteLocalDeficiencyTicket(id: IMSId): Promise<void> {
    let db = await this.dbPersistenceService.getImsDb();
    try {
      await this.dbPersistenceService.executeStatement(db, {
        statement:
          'DELETE FROM ' +
          this.localDeficiencyTicketTableDefinition.tableName +
          ' WHERE id = (?);',
        parameters: [id.secondaryId],
      });
    } catch (error) {
      this.logger.log(
        'Error deleting local DeficiencyTicket',
        id,
        'from db',
        error,
      );
    }
  }

  public async reset() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.localDeficiencyTicketTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.localDeficiencyTicketTableDefinition.tableName,
    );
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.deficiencyTicketTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.deficiencyTicketTableDefinition.tableName,
    );
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.localDeficiencyTicketTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.localDeficiencyTicketTableDefinition.tableName,
    );
  }

  public async clearRemoteDeficiencyTickets() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.deficiencyTicketTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.deficiencyTicketTableDefinition.tableName,
    );
  }
}
